import { useNavigate } from 'react-router-dom';
import { Linkedin, Twitter, Instagram, Facebook } from 'lucide-react';
import { Separator } from '../ui/separator';
import { NLPLogo } from './NLPLogo';

const navigationLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '#about' },
  { label: 'Features', href: '#features' },
  { label: 'FAQ', href: '#faq' },
];

const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Service', path: '/terms' },
  { label: 'Disclaimer', path: '/disclaimer' },
];

const socialLinks = [
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Facebook, href: '#', label: 'Facebook' },
];

export function NLPFooter() {
  const navigate = useNavigate();

  const handleNavClick = (href: string) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      element?.scrollIntoView({ behavior: 'smooth' });
    } else if (href.startsWith('/')) {
      navigate(href);
    }
  };

  return (
    <footer className="py-16 md:py-24 px-4 md:px-8 bg-nlp-bg border-t border-nlp-cream-dark">
      <div className="max-w-[1216px] mx-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
          <div className="max-w-md">
            <div className="mb-6">
              <NLPLogo className="h-12" />
            </div>
            <p className="text-lg text-nlp-taupe mb-6 leading-relaxed">
              Building a growth mindset starts with understanding yourself — and
              NLP OS is here to guide you every step of the way.
            </p>
            <nav className="flex flex-wrap gap-6">
              {navigationLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => handleNavClick(link.href)}
                  className="text-md font-semibold text-nlp-forest/70 hover:text-nlp-forest transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="flex flex-col sm:flex-row gap-8">
            <div>
              <h4 className="font-bold text-nlp-forest mb-4">Legal</h4>
              <div className="space-y-3">
                {legalLinks.map((link) => (
                  <button
                    key={link.label}
                    onClick={() => navigate(link.path)}
                    className="block text-nlp-taupe hover:text-nlp-forest transition-colors"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-nlp-cream-dark" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8">
          <p className="text-sm text-nlp-taupe">
            Copyright 2025 NLP OS, All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-nlp-cream text-nlp-forest hover:bg-nlp-forest hover:text-nlp-bg transition-colors"
                aria-label={social.label}
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
